
export default function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-[#F5F5F3] to-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">Pricing</h2>

        <div className="max-w-lg mx-auto">
          <div className="bg-white rounded-[32px] shadow-xl p-12 text-center">
            <div className="text-6xl font-bold text-gray-900 mb-4">
              $50<span className="text-2xl text-gray-600 font-normal"> / month</span>
            </div>

            <p className="text-gray-600 mb-10">
              No contracts <span className="mx-2">•</span> Cancel anytime
            </p>

            <a
              href="https://calendar.app.google/fm26XKpqmgC8oisS7"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-4 bg-[#2B2B2B] text-white text-lg font-semibold rounded-full hover:bg-[#1a1a1a] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Book your Free 30-minute Consult!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
